// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1VCk9","bigColWidth":"Table_bigColWidth__1InyW","biggerColWidth":"Table_biggerColWidth__1V4wp","row":"Table_row__2wtZ6","col":"Table_col__180kJ"};